import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  display: grid;
  grid-template-columns: 17px 1fr auto;
  align-items: center;
  gap: 10px;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  padding: 15px;
  height: 55px;
`;

export const Number = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const Action = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.blue};
  text-decoration: underline;
  line-height: 1;
`;
